export default {
      id: "notifications__stop-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__stop",
      toString: function () {
        return this.url;
      }
    }